import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import { form } from "../Service/Api";
import { getHeader } from "../config";
const Clubs = () => {
  return (
    <>
      <Header />
      <Breadcrumb title="Clubs" tabName="Clubs" />
      <div className="innerPage">
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="col-md-12">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/coming-soon.jpg"
                    alt="Nirmala Convent School Rajkot"
                    className="img-fluid m-auto d-block"
                    style={{ maxWidth: "400px", height: "auto" }}
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Clubs;
